export default "__VITE_ASSET__4pq7hIwA__"